import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { withShareLandingContainer, LandingDescription } from '@common/containers/Landing';

import { ILandingProps } from './types';

import * as s from './Landing.scss';

class LandingContainer extends React.PureComponent<ILandingProps> {

	render() {
		const { landing, locales, urls } = this.props;
		const { copyright } = getConfig();

		return (
			<div
				className={s.container}
			>
				<div/>
				<div className={s.content}>
					<LandingDescription
						landing={landing}
						locales={locales}
						classNames={{
							blockClassName: s.descriptionBlock,
							storesClassName: s.stores,
						}}
					/>
				</div>
				<div className={s.footer}>
					<div className={s.footerLinks}>
						<a
							className={cn(s.link, s.termsLink)}
							href={urls.terms}
							target="_blank"
							rel="noopener noreferrer"
						>
							{locales.terms}
						</a>
						<a
							className={cn(s.link, s.feedbackLink)}
							href={urls.feedback}
							target="_blank"
							rel="noopener noreferrer"
						>
							{locales.feedback}
						</a>
					</div>

					<div className={s.copyright}>{copyright}</div>
				</div>
			</div>
		);
	}

}

export const Landing = withShareLandingContainer(LandingContainer, {
	blockClassName: s.block,
});
